import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icons-image',
  imports: [],
  templateUrl: './icons-image.component.html',
  styleUrl: './icons-image.component.scss',
})
export class IconsImageComponent {
  @Input() name = '';
  @Input() size = 24;
}
